import type {PermissionsRecordType} from '../permissions';

export const carAuditPermissions = {
  createInspection: {
    actionId: 'CREATE',
    resourceId: 'CAR_AUDIT_INSPECTION',
    scopes: ['CAR_AUDIT_INSPECTION.INSPECTION_TYPE'],
  },
  readInspection: {
    actionId: 'READ',
    resourceId: 'CAR_AUDIT_INSPECTION',
    scopes: ['CAR_AUDIT_INSPECTION.INSPECTION_TYPE', 'PARTICIPATION'],
  },
  updateInspection: {
    actionId: 'UPDATE',
    resourceId: 'CAR_AUDIT_INSPECTION',
    scopes: [
      'CAR_AUDIT_INSPECTION.INSPECTION_TYPE',
      'PARTICIPATION',
      'CAR_AUDIT_INSPECTION.INSPECTION_STATE',
    ],
  },
  deleteInspection: {
    actionId: 'DELETE',
    resourceId: 'CAR_AUDIT_INSPECTION',
    scopes: ['CAR_AUDIT_INSPECTION.INSPECTION_TYPE', 'PARTICIPATION'],
  },
  beginInspection: {
    actionId: 'BEGIN',
    resourceId: 'CAR_AUDIT_INSPECTION',
    scopes: [
      'CAR_AUDIT_INSPECTION.INSPECTION_TYPE',
      'PARTICIPATION',
      'CAR_AUDIT_INSPECTION.INSPECTION_STATE',
    ],
  },
  finishInspection: {
    actionId: 'FINISH',
    resourceId: 'CAR_AUDIT_INSPECTION',
    scopes: [
      'CAR_AUDIT_INSPECTION.INSPECTION_TYPE',
      'PARTICIPATION',
      'CAR_AUDIT_INSPECTION.INSPECTION_STATE',
    ],
  },
  closeInspection: {
    actionId: 'CLOSE',
    resourceId: 'CAR_AUDIT_INSPECTION',
    scopes: ['CAR_AUDIT_INSPECTION.INSPECTION_TYPE', 'PARTICIPATION'],
  },
  reopenInspection: {
    actionId: 'REOPEN',
    resourceId: 'CAR_AUDIT_INSPECTION',
    scopes: ['CAR_AUDIT_INSPECTION.INSPECTION_TYPE', 'PARTICIPATION'],
  },
  returnForFinishingInspection: {
    actionId: 'RETURN_FOR_FINISHING',
    resourceId: 'CAR_AUDIT_INSPECTION',
    scopes: [
      'CAR_AUDIT_INSPECTION.INSPECTION_TYPE',
      'PARTICIPATION',
      'CAR_AUDIT_INSPECTION.INSPECTION_STATE',
    ],
  },
  reviseInspection: {
    actionId: 'REVISE',
    resourceId: 'CAR_AUDIT_INSPECTION',
    scopes: [
      'CAR_AUDIT_INSPECTION.INSPECTION_TYPE',
      'PARTICIPATION',
      'CAR_AUDIT_INSPECTION.INSPECTION_STATE',
    ],
  },
  carAuditShareLink: {
    resourceId: 'CAR_AUDIT_INSPECTION',
    actionId: 'SHARE',
    scopes: [],
  },
  carAuditTypeOfControlCreate: {
    resourceId: 'CAR_AUDIT_TYPE_OF_CONTROL',
    actionId: 'CREATE',
    scopes: ['CAR_AUDIT_INSPECTION.INSPECTION_TYPE'],
  },
  carAuditTypeOfControlUpdate: {
    resourceId: 'CAR_AUDIT_TYPE_OF_CONTROL',
    actionId: 'UPDATE',
    scopes: ['CAR_AUDIT_INSPECTION.INSPECTION_TYPE'],
  },
  carAuditTypeOfControlDelete: {
    resourceId: 'CAR_AUDIT_TYPE_OF_CONTROL',
    actionId: 'DELETE',
    scopes: ['CAR_AUDIT_INSPECTION.INSPECTION_TYPE'],
  },
  carAuditTypeOfControlRead: {
    resourceId: 'CAR_AUDIT_TYPE_OF_CONTROL',
    actionId: 'READ',
    scopes: ['CAR_AUDIT_INSPECTION.INSPECTION_TYPE'],
  },
} satisfies PermissionsRecordType;
